import { useSyncExternalStore } from "react";
import { appSettings } from "./appSettingsManager";
export const useAppSettings = () => {
    return useSyncExternalStore(appSettings.subscribe, appSettings.getSettings);
};
export const useAppSettingsInitialized = () => {
    return useSyncExternalStore(appSettings.subscribe, appSettings.getIsInitialized);
};
export const useAppSettingsError = () => {
    return useSyncExternalStore(appSettings.subscribe, appSettings.getError);
};
